import {
    getReportSubscriptionData,
    removeReportSubscriptionData,
    saveReportSubscriptionData,
    updateReportSubscriptionData,
    toggleReportSubscriptionActiveStatusForUser,
} from "./api/report-subscription.api";

const getReportSubscription = async (type) => {
  try {
    const res = await getReportSubscriptionData(type);
    return res;
  } catch (e) {
    console.log(e);
  }
};

const saveReportSubscription = async (body) => {
  const res = await saveReportSubscriptionData(body);
  return res;
};

const removeReportSubscription = async (id, deleteForAll = false) => {
  try {
    const res = await removeReportSubscriptionData(id, deleteForAll);
    return res;
  } catch (e) {
    console.log(e);
  }
};

const updateReportSubscription = async (id, body) => {
  try {
    const res = await updateReportSubscriptionData(id, body);
    return res;
  } catch (e) {
    console.log(e);
  }
};

// const toggleReportSubscriptionActive = async (id, isActive) => {
//   try {
//     const res = await toggleReportSubscriptionActiveStatus(id, isActive);
//     return res;
//   } catch (e) {
//     console.log(e);
//   }
// };

const toggleReportSubscriptionActiveForUser = async (id, isActive) => {
  try {
    const res = await toggleReportSubscriptionActiveStatusForUser(id, isActive);
    return res;
  } catch (e) {
    console.log(e);
  }
};

export {
  getReportSubscription,
  saveReportSubscription,
  removeReportSubscription,
  updateReportSubscription,
  toggleReportSubscriptionActiveForUser,
};
